import {
  updatePage,
  updateSelectedService,
} from '../../reducers/app/appReducer';
import { updatePostCodeInSearch } from '../../reducers/search/searchReducer';
import store from '../../store';
import type { FollowUpPage } from '../../types/app';

export interface FollowUpPageData {
  serviceId: string;
  zipCode: string;
}

// TODO: Replace this temporary data once the follow-up context source and contract are defined.
export const getFollowUpPageData = (): FollowUpPageData => ({
  serviceId: 'BUSINESS_PLANNING',
  zipCode: '',
});

export const initializeFollowUpPage = (
  pageData: FollowUpPageData,
  page: FollowUpPage,
): FollowUpPageData => {
  store.dispatch(updatePage(page));
  if (pageData.serviceId) {
    store.dispatch(updateSelectedService({ serviceId: pageData.serviceId }));
  }
  if (pageData.zipCode) {
    store.dispatch(updatePostCodeInSearch(pageData.zipCode));
  }

  // TODO: Resolve the follow-up service to its operation and load service metadata before fetching time windows.
  // TODO: Load the original appointment, coworker, and customer context once the source is defined.
  return pageData;
};
